import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface NotificationItemProps {
  text: string;
  count: number;
  isMapped?: boolean;
}

export function NotificationItem({ text, count, isMapped = false }: NotificationItemProps) {
  const content = (
    <div className="flex items-center justify-between p-3 hover:bg-accent rounded-md cursor-pointer transition-colors focus:outline-none focus-visible:outline-none">
      <span className={`text-sm text-foreground ${!isMapped ? 'italic' : ''}`}>{text}</span>
      <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
        <span className={`text-xs font-medium text-primary-foreground ${!isMapped ? 'italic' : ''}`}>{count}</span>
      </div>
    </div>
  );

  if (!isMapped) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {content}
          </TooltipTrigger>
          <TooltipContent>
            <p>Endpoint mapping missing</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}